export default function selectGoal(goalValue) {
  if(goalValue === "goals.generalGoal") return "Descrição do objetivo"
  if(goalValue === "goals.steps") return "Quantidade de passos"
  if(goalValue === "goals.caloriesOut") return "Quantidade de calorias gastas"
  if(goalValue === "goals.activeMinutes") return "Quantidade de horas ativas"
  if(goalValue === "goals.sedentaryMinutes") return "Quantidade de horas sedentárias"
  if(goalValue === "goals.wakeMinutes") return "Quantidade de tempo acordado"
  if(goalValue === "goals.remMinutes") return "Quantidade de horas de sono REM"
  if(goalValue === "goals.lightMinutes") return "Quantidade de horas de sono leve"
  if(goalValue === "goals.deepMinutes") return "Quantidade de horas de sono profundo"
  if(goalValue === "goals.awakeMinutes") return "Quantidade de tempo sem sono"
}